<template>
  <transition name="fade">
    <div
      class="Modal"
      :style="{ display: scrollCheck, opacity: scrollopacity }"
    >
      <div class="container">
        <!-- To basins modal position -->
        <!-- <div class="scrollY">Scroll-Y is {{ scrollPosition }}</div> -->
        <!-- <div>{{ scrollCheck }}</div> -->
        <!-- <div>Rounded to the nearest 100: {{ scrollBlock }}</div> -->
        <!-- end modal position basins  -->
        <div class="child">
          <button type="button" name="button" v-on:click="$emit('decrease')">
            {{ filters[this.counter - 1] }}
          </button>
        </div>
        <div class="child2">
          {{ filters[this.counter] }}
        </div>
        <div class="child3">
          <!-- Simplest - call `$emit()` inline-->
          <button type="button" name="button" v-on:click="$emit('increment')">
            {{ filters[this.counter + 1] }}
          </button>
        </div>
        <div class="item-a">
          <svg
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 414 609"
            :style="{
              fill: 'none',
            }"
          >
            <defs></defs>
            <!-- #f8fcfd -->
            <image width="552" height="812" transform="scale(0.75)" />
            <path
              class="cls-1"
              :style="
                hoverCentral === basins[0]
                  ? {
                      fill: '#3A5311',
                      opacity: 1,
                    }
                  : {
                      fill: sortedBasinOnlyNames.includes(basins[0])
                        ? coloring(basins[0])
                        : '#f8fcfd',
                      opacity: 1,
                    }
              "
              d="M7320.77,7249.83c-.92-5.17,1.71-11.61-5.24-14.61h-8.7l-3.5,8.53-12.71-.42-2.2,2.46c-.43,1.2,2.23,3.71,2.85,4.34,3.39,3.46,3.19,7.64,3.51,12a7.72,7.72,0,0,1-2.86,7.1c-3,2.62-6,5.46-9.39,7.41-4.18,2.38-4.53,6.8-6.63,10.26a186.78,186.78,0,0,1-13.64,19.72c-3,3.72-4.37,7.95-6.27,12.07-.77,1.69-.16,3.43.16,4.85,1.14,5-.16,9.22-3.94,12.32a21.55,21.55,0,0,0-7.92,12.48c-1,5.6-3.29,12,.93,17.38l-.28,2.77c4.62.22,12.11.38,16.73.47,6.23.12,12.07-1,18.3-1.27,5-.24,9.66,1.75,14.6,1.2l.75.38c1.5,1,3.24,0,4.9.64a2.82,2.82,0,0,0,3.71-1.77l.37,1.13c2.62,1.63,5.5.65,8.24.68,7.48.1,7.59,0,7.44-7.43-.09-4.38-.9-8.76.4-13.11.43-1.46.73-2.48,2.59-3.12,3.21-1.12,7.08-2.29,7.82-6.26.89-4.8,4.49-9.16,3.17-14.33-.14-.57.11-1.32.65-1.12l.31-.83c.37-2.82-.52-1-1.09-1.94-.33-2.72-.29-3.22-.6-5.74-.26-2.06-.26-4.63.75-6.29,4.45-7.31,2.66-14.94,1.72-22.53-.41-3.38-1.94-6.67-1.4-10.11.7-4.48-1.4-7.51-4.59-10.06-.35-.28-1.2-.3-1.43-.82-2.31-5.27-7.58-9.2-7.13-15.72Z"
              transform="translate(-7004.84 -6879.99)"
            />
            <path
              class="cls-2"
              :style="
                hoverCentral === basins[5]
                  ? {
                      fill: '#3A5311',
                      opacity: 1,
                    }
                  : {
                      fill: sortedBasinOnlyNames.includes(basins[5])
                        ? coloring(basins[5])
                        : '#f8fcfd',
                      opacity: 1,
                    }
              "
              d="M7320.77,7050.36c.25-2,10.8,2.73,11.06.65,7.71-6.07,8.57-2.61,8.28,9.62-.25,10.57,3.89,15.87,4.5,23.94.32,4.15,1.67,7.89,1.28,12.67-.07.9-.72,5.38-1.93,6.24-1,.73-3.07-.73-3.7.45-.44.83-.33,6.82.35,7.48a3,3,0,0,1,1.12,2.63l1.13.37a2.11,2.11,0,0,0-1.43,3c.86,2.28,0,4.53.13,6.78.11,2,0,4.34-2.35,6.11-2.82,2.12-3,6.06-4.16,9.25-2.14,5.92-3.25,12.16-6.64,17.68a5.11,5.11,0,0,0,1,6.28c2.08,1.84,3.64,4.1,6.68,5,2.45.77,3.94,3.35,4.59,6.18,1.28,5.53,1.75,10.64-.95,16.22-2.26,4.67-2.51,10.26-1.93,15.63l.22.37c-1.33,4.37-4.82,6.82-8.2,9.41-.72.56-1.31.29-1.91.29-2.24,0-4.43,1-5.11,2.71-1.81,4.63-1.76,7.47-4.8,11a1.8,1.8,0,0,0-.22,2,1.83,1.83,0,0,1-1.62,2.67h-9.59l-3.5,8.53-12.71-.42-2.21,2.46-6.69-6c-4.77-3.1-6.52-8.15-8.93-12.8-2-3.87-4.89-7.23-8.69-8.82-5.89-2.46-8.22-7.17-10-12.52-1.53-4.54-1.23-5.22,3.36-6.3a10.81,10.81,0,0,0,7.08-4.94c1.21-2,2.22-4,3.4-6,4.25-7.1,6.06-15.29,10.13-22.45.32-.55.2-1,.35-1.52,1.52-5,3-10,2.61-15.36v-.38c0-1.87.57-4-.11-5.57-1.72-4-.34-7.53.44-11.29,1.13-5.44,3-10.79,2.66-16.47v-1.5c-.39-3.62,1.07-7,1.38-10.5a34.08,34.08,0,0,1,5.72-16.1c1-1.44,2.46-3,2.5-4.49.08-3.66,2.28-5.79,4.65-7.83,3.9-3.35,7.89-6.61,12-9.74,5-3.86,9.82-7.84,10.84-14.64"
              transform="translate(-7004.84 -6879.99)"
            />
            <!-- EDIT THIS ONE V -->
            <g id="_Group_" data-name="&lt;Group&gt;">
              <path
                class="cls-1"
                :style="
                  hoverCentral === basins[13] || hoverCentral === basins[18]
                    ? { opacity: 1, fill: '#3A5311' }
                    : { fill: coloring(basins[13]) }
                "
                d="M7315.72,7235.22c6.95,3,4.32,9.44,5.24,14.61l.37.75c-.44,6.52,4.82,10.45,7.14,15.72.23.52,1.08.54,1.42.82,3.2,2.55,5.3,5.58,4.6,10.06-.54,3.44,1,6.73,1.4,10.11.94,7.59,2.73,15.22-1.72,22.53-1,1.66-1,4.23-.75,6.29.31,2.52.27,3,.6,5.74.57,1,1.46-.88,1.09,1.94l-.31.83c-.54-.2-.79.55-.65,1.12,1.32,5.17-2.28,9.53-3.18,14.33-.73,4-4.6,5.14-7.81,6.26-1.86.64-1.24-.41-1.67,1l-.78,1.59c-1.29,4.35,0,16.71.06,21.09l1.48.2c5.72.84,10-.07,15.74.19.6,0,1.44-.23,1.92.06a4.77,4.77,0,0,0,3.42.78l25.63-.16v-3.79l-1.42-1.37-.5-2.79-.62-2.63s.33-1.58-.09-1.87-2.87-2.3-2.87-2.3l-1.34-1.58s-.41-1.25-.54-1.46-.58-.66-.75-.87-.66-1.29-.66-1.29l-.09-2.05-.08-6.33-2.58-1.58.62-1.67s-.71-.17.88-1a8.88,8.88,0,0,0,2.25-1.5c.37-.38,1.2-2,.83-2.92s.08-5.16.08-5.16l2.09-2.5.45-5.67.88-20.25-2.5-1.13-.63-1.75-1.2-1.62-.05-1.46-1.58-2s-.5-.12-.54-1.29,0-9.29,0-9.29l-1.55-11.2c1.4-1.15,4.58-.84,3.37-4.12l3.51-3.47a16.4,16.4,0,0,0,2.13-2.71c.29-.75,0-19.67,0-19.67l3-2.24c2,0,3.67-.29,3.42-3-.11-1.13.94-1.18,1.82-1.12l1.13-1.12c-.95-4.76,3.53-5.29,5.24-6.57l1-.7-.73-.55s-2.87-2.45-3-2.53-2.66-.33-2.66-.33-.05-1.25-.21-1.3l-3.25-.58-3.17-.62-.33-1.84,3.12-1.21,1.13-4.25,0-8.08-1.46-.37.58-3.38.63-4.71-1-2.12-9.29-10,1.58-4.46-2.17-3.21s-.12-4.42,0-5.58-2.12-7-2.12-7h-2.5l-2-8.56c1.95-1.63,1.43-3.88,1.5-6h.16l-.79-8.41-1.54-1.54-.25-7.38-1.58-1.95-.29-6.88-1.17-3.29-1.83-10-.5-7.75-.17-2.34-4.25,3.91-3.74-.6-.6,1c-.44.83-.33,6.81.36,7.48a3,3,0,0,1,1.12,2.62l1.12.38a2.11,2.11,0,0,0-1.42,3c.85,2.28,0,4.53.12,6.77.12,2,0,4.35-2.35,6.12-2.81,2.12-3,6.06-4.16,9.25-2.14,5.91-3.24,12.16-6.63,17.68a5.09,5.09,0,0,0,1,6.27c2.09,1.85,3.65,4.1,6.69,5.05,2.44.76,3.93,3.35,4.59,6.18,1.27,5.53,1.74,10.63-1,16.22-2.26,4.67-2.51,10.26-1.92,15.62l.21.38c-1.33,4.36-4.82,6.81-8.2,9.41-.72.56-1.31.29-1.9.29-2.24,0-4.44,1-5.12,2.71-1.81,4.62-1.76,7.46-4.79,11a1.82,1.82,0,0,0-.23,2l.2,1-2.13,1.6"
                transform="translate(-7004.84 -6879.99)"
              />
            </g>
            <path
              class="cls-3"
              :style="
                hoverCentral === basins[1]
                  ? { fill: '#3A5311', opacity: 1 }
                  : {
                      fill: sortedBasinOnlyNames.includes(basins[1])
                        ? coloring(basins[1])
                        : '#f8fcfd',
                    }
              "
              d="M7222.32,7051c2.25-1.05,4.86-1.57,7-2.39,5.25-2.08,9.5-3.75,13.28-7,6.95-6,10.5-16.47,17.44-23.06,1.78-2.45,3.62-4.77,6.52-6,7.93-4.85,13.65-11.53,19.43-18,2.93-8,6.05-15.37,13-19.94,1.4-1.58,2.9-3,4.36-4.69,4-4.78,7.43-12.17,11.58-15.15l3.63-18.65-.74,4.5c.92,5.06,2.54,8.9,2.14,13.73a13.22,13.22,0,0,0,.16,3.32c.43,2.75,1.16,5.59,1.5,7.82.74,4.8,2.43,9.51,3.09,14.5,2.88,10.17,3.27,20.62,4.58,30.67.43,3.33,1.84,6.54,1.76,10.09.74,6.38,2.39,10.13,3.24,16.49.49,3.74,5.68,6.32,3.74,10.17l-6.18,4.65c-.26,2.07-10.27-3.36-10.52-1.36l-.54.71c-1,6.8-5.81,10.77-10.84,14.63-4.08,3.13-8.07,6.39-12,9.74-2.38,2-4.57,4.17-4.66,7.83,0,1.52-1.53,3.05-2.49,4.49a34,34,0,0,0-5.72,16.11c-.31,3.49-1.77,6.87-1.38,10.49v1.5c.3,5.68-1.54,11-2.66,16.47-.78,3.77-2.16,7.33-.45,11.3.69,1.57.12,3.69.12,5.57v.37c.42,5.34-1.09,10.35-2.62,15.36a5.31,5.31,0,0,1-.34,1.52c-4.07,7.16-5.89,15.36-10.14,22.45-1.17,2-2.18,4-3.39,6a10.81,10.81,0,0,1-7.08,4.94l-4.11,1.14a28,28,0,0,1-4.46-2.29,14.32,14.32,0,0,0-7.15-2.54c-5.5-.69-8.81-3.35-10.5-8.65a18.82,18.82,0,0,0-1.87-4.11c-3.31-5.28-7.2-10.27-9.9-15.83-1.64-3.37-3.93-6.32-5.24-10-1.9-5.24-2.42-10.95-5.32-15.86l-7.59-5.18c2.75-.54,3-2.42,3.07-4.87a123.5,123.5,0,0,1,2.11-18.36c.79-4.18,3.36-7.33,5.28-10.86,1.82-3.34,3.62-6.71,6.41-9.33,3-2.88,5.42-6.31,8.23-9.37,2-2.16,2.36-5.6,4.91-7,2-1.09,2.37-2.24,2.65-4.23a27.87,27.87,0,0,1,1.75-7.52c2.26-5,1.76-8.38-2.51-12.95Z"
              transform="translate(-7004.84 -6879.99)"
            />
            <path
              class="cls-2"
              v-on:mousedown="logit()"
              :style="
                hoverCentral === basins[11]
                  ? { fill: '#3A5311', opacity: 1 }
                  : {
                      fill: sortedBasinOnlyNames.includes(basins[11])
                        ? coloring(basins[11])
                        : '#f8fcfd',
                    }
              "
              d="M7260,7018.47c1.78-2.45,3.62-4.77,6.52-6,7.93-4.85,13.65-11.53,19.43-18,2.93-8,6.05-15.37,13-19.94,1.4-1.58,2.9-3,4.36-4.69,4-4.78,7.43-12.17,11.58-15.15l3.63-18.65-.74,4.5.72-4.67-4.47-28.67h-247.8l5.77,7.55-5.77,52.76a2.68,2.68,0,0,0,.8,1.37c.53.55.39,1.09,0,1.74l10.44,9.25c2.28,2.48,6.06,2.51,8.27,5.21a25.76,25.76,0,0,0,9.71,7.12c3.69,1.63,7.48,3,11.22,4.52l.75.37c2.24.83,4.09,1.8,5.2.42l.41,0c1.25-.57,2.33.87,3.78.06l10.66-3.49,2.41-6.31c0-3.44.16-6.76,4.11-8.25,1.79-.67,4.56-2.44,6.43-2.67.14,0,6.45-1.32,6.59-1.29l5,2.84c.1,0,1,.84,1.08.89,4.15,2,3.72,4.64,5.61,6.23l2.62,2.25c.87,0,2.19.37,2.55-.06,2.42-2.89,5.64-2.1,8.68-2.18,2.24-.05,4.51.15,6.73-.05,2.82-.25,4.3,1.13,5.7,3.37,1.11,1.77,1.53,4.73,4.79,4.16h6c4.41-2.06,9.6-1.48,13.87-4.08a2,2,0,0,1,1.82,0c2.22,1.65,3.85.92,6.25,1.05a14.67,14.67,0,0,1,2.36.13c.4.16.95-.54.95-.54l.1-.31a.75.75,0,0,1,.46-.52c2.06-.82,4.11-1.64,6.38-.6l.75.37c3.87.91,4,1.14,3.39,5.25-.18,1.26-.29,4.1-1.53,5.66-.71.89-.72,1.7-.77,4.15a2,2,0,0,0,1,1.78h0a1.54,1.54,0,0,0,1.37.05c2.78-1.25,3.82-1,4.78-2a4.43,4.43,0,0,0,1.05-1.45c1-4.49,3.94-6,8.27-5.63,2.72.21,5.5.38,7.86-1.47h1.5c2.49-.16,3.13,3.15,5.61,3l1.5,1.13a65,65,0,0,1,2.14,9.78c0,.23-1,5.22-1.39,5.22Z"
              transform="translate(-7004.84 -6879.99)"
            />
            <path
              class="cls-4"
              :style="
                hoverCentral === basins[10]
                  ? { fill: '#3A5311', opacity: 1 }
                  : {
                      fill: sortedBasinOnlyNames.includes(basins[10])
                        ? coloring(basins[10])
                        : '#f8fcfd',
                    }
              "
              d="M7086.07,7156.94c-.13,2,.8,2.35-1.47,8.24-1.84,4.77,6,9.33,6.35,14.54.24,3.62,1.11,7.23,1,10.93-.06,2.7,1.63,3.44,3.46,3.65s2.85.52,3.89,2.25c.69,1.16,2.25.31,4.39.62,1.56-1.72,4.05-1.68,6.22-2.4,4.21-1.39,8-.34,8.78,3.84,2.18,3.31,3,3,6.45,4.22l1.22-.33c2.51-9.15,5.51-17.17,12.4-24l2.25-8.61c.79-1.34,1.2-.4.94-1.67l.33-7.8c3.74-2.37,2.61-5.65,2.9-8.76v-7.49c.78-4.12,1-8.45,4.85-11.26a1.42,1.42,0,0,0,.37-1.1c-.36-4.22,2.65-6.89,4.47-10.14,1.13-2,2.7-4,2-6.74a3.25,3.25,0,0,1,2.15-3.74c2.77-1.18,5.49-2.48,8.24-3.73l.75-.37a23.91,23.91,0,0,0,4.49-6H7177c.54.54.88.92,1.91.44,2.06-1,1.57-3.33,3-4.56l.37-.75a5.89,5.89,0,0,1,3.74-3.75l.75-.37c1.58-.6.64-2.59,1.88-3.37l.74-1.5c.37-1.09,2.22-.38,2.25-1.87l6.36-4.12c2.58-3.29,7.07-4,9.74-7.12l1.12-1.12c1.45-.53.44-2.77,1.51-2.9,2.9-.35,3.24-2.81,4-4.63,1.21-2.83,2-5.82,4.58-7.82a1.18,1.18,0,0,0,.33-1.49c-1.26-2.35.77-3.23,1.91-4.51l1.12-.75c2.25-1.05,4.86-1.57,7-2.39,5.25-2.08,9.5-3.75,13.28-7,6.95-6,10.14-16.12,17.08-22.71l.36-.35,3.5-4.58c.37,0,1.4-5,1.39-5.22a65,65,0,0,0-2.14-9.78l-1.5-1.13c-2.48.16-3.12-3.15-5.61-3h-1.5c-2.36,1.85-5.14,1.68-7.86,1.47-4.33-.34-7.25,1.14-8.27,5.63a4.43,4.43,0,0,1-1.05,1.45c-1,1-2,.72-4.78,2a1.54,1.54,0,0,1-1.37-.05l-.17-.05-.76-.49c-.65-.35-.12-.5-.1-1.24.05-2.45.06-3.26.77-4.15,1.24-1.56,1.35-4.4,1.53-5.66.58-4.11.48-4.34-3.39-5.25l-.75-.37c-2.27-1-4.32-.22-6.38.6-.23.09-.47.12-.53.35l.26.3-.29.18s-.55.7-.95.54a14.67,14.67,0,0,0-2.36-.13c-2.4-.13-4,.6-6.25-1.05a2,2,0,0,0-1.82,0c-4.27,2.6-9.46,2-13.87,4.08h-6c-3.26.57-3.68-2.39-4.79-4.16-1.4-2.24-2.88-3.62-5.7-3.37-2.22.2-4.49,0-6.73.05-3,.08-6.26-.71-8.68,2.18-.36.43-1.68.06-2.55.06l-2.62-2.25c-1.89-1.59-1.46-4.24-5.61-6.23-.09-.05-1-.87-1.08-.89l-5-2.84c-.14,0-6.45,1.27-6.59,1.29-1.87.23-4.64,2-6.43,2.67-3.95,1.49-4.13,4.81-4.11,8.25l-2.41,6.31-5.83,11.67-.37.75c-1.51,1.7-.5,3.74-.73,5.62-.26,2.12.52,4.36-.77,6.36l-1.5,6c-1.48.5,0,2.48-1.49,3l-1.88,2.62c-1.49,3.6-1.17,7.54-2.09,11.28a10.12,10.12,0,0,1-2.05,4.43c-2.54,2.94-3.33,6.7-4.3,10.18a21.09,21.09,0,0,0-.36,10.4c1.29,5,.36,10.08,1.32,15l.37.74c1.4,1.2,1.46,2.8,1.53,4.5.2,4.88-1.17,9.72-.39,14.6.24,1.57-1.4,1.66-1.89,2.63l-.37.75a44,44,0,0,1-3.74,13.66c-2.32,4.85-7.17,7.9-8.24,13.3-.23,1.13-1,2.38-.67,3.35,1.08,3.67-1.61,6.58-2.13,9.66a25.18,25.18,0,0,1-5.43,11.71"
              transform="translate(-7004.84 -6879.99)"
            />
            <path
              class="cls-5"
              :style="
                hoverCentral === basins[12]
                  ? { fill: '#3A5311', opacity: 1 }
                  : {
                      fill: sortedBasinOnlyNames.includes(basins[12])
                        ? coloring(basins[12])
                        : '#f8fcfd',
                    }
              "
              d="M7107.41,7348.33c-3.12-2.76-7-1.37-10.5-1.76a28,28,0,0,1-14.15-6.18c-1.32-1-1.31-2.84-.08-4.44,1.76-2.27,2.85-5,4.88-7.1,4.76-4.9,5-11.64,6.11-17.65,1.35-7.09,5-12.34,9.71-17.09,3-3,4.55-5.91,3.71-10.21-1.12-5.73-.47-11.48,2.65-16.41,3.95-6.24,3.92-12.35,1-18.78a3,3,0,0,1-.49-2.28,11,11,0,0,0-.57-6c-1.33-3.7.22-10.4,3-11,3.59-.82,6.63-3.27,10.44-3.18a7.31,7.31,0,0,0,5.64-2.6c2.73-2.8,3.07-8.37.75-12.39-1.23-2.13-3.65-4.11-2.93-6.71,2.51-9.15,5.31-19.2,12.2-26l2.25-8.61,2,2.35c0,1.83,1.56,10.16,1.73,14l.05.83c.49,3.5.79,8.12,4.11,11.11,1.83,1.74,2,4.51,2.13,7h.56c1.44,1.49,2.13,4.07,3.2,5,3.61,3.15,5.85,9.32,12.52,7.36l.48-.68a19.67,19.67,0,0,1,4.85-10.48c5.06-6,6.76-13.5,10-20.3v-2.25c1.06-2,1.23-4.16,1.61-6.35s0-4.51.92-6.79c3.17-7.8,5.47-15.91,8.94-23.63,1.51-3.36,3-6.49,5.74-8.92l.93-1.18,7.79,4.86c2.9,4.91,3.42,10.62,5.32,15.86,1.31,3.64,3.6,6.59,5.24,10,2.7,5.56,6.59,10.55,9.9,15.83a18.82,18.82,0,0,1,1.87,4.11c1.69,5.3,5,8,10.5,8.65a14.32,14.32,0,0,1,7.15,2.54,28,28,0,0,0,4.46,2.29l.77,4.28c1.8,5.35,4.13,10.06,10,12.52,3.8,1.59,6.69,5,8.69,8.82,2.41,4.65,4.16,9.7,8.93,12.8l-4.83-2.84c-2.25,1.62-4.59,3.13-6.71,4.9s-4.82,2.37-7.5,3a39,39,0,0,0-7.85,3c-7.06,3.5-12.68,9.17-19.48,13.09-5.15,3-7.41,2.7-10.86-1.71-3.66-4.65-7.33-5.85-11.6-3.73-1.53.75-3,1.61-4.5,2.42l-.75,1.13c-3,5.38-5.41,11-8.88,16.17s-8.54,7.14-14,4.45c-3.29-1.64-6.53-3.39-10.48-3.08-2.41.19-3.92,1.06-4.49,3.43l-1.49,2.25c-3.23,9.34-7.32,18.1-17.62,21.46-5.12,1.67-8.69,5.48-13,8.19a8.37,8.37,0,0,1-2.65,1.51c-2.91.72-5.22,2.38-6,5.54l.75,4.12c2.48,9.23-.8,14.4-6.89,20.37l-3,2.08c-4.09,1.11-6.8,3.58-11.42,3.4Z"
              transform="translate(-7004.84 -6879.99)"
            />
            <!-- EDIT THIS ONE v -->
            <path
              class="cls-6"
              :style="
                hoverCentral === basins[2] ||
                hoverCentral === basins[14] ||
                hoverCentral === basins[15] ||
                hoverCentral === basins[19] ||
                hoverCentral === basins[20]
                  ? { fill: '#3A5311' }
                  : { fill: coloring(basins[2]) }
              "
              d="M7127.46,6994l-5.83,11.67-.37.75c-1.51,1.7-.5,3.74-.73,5.62-.26,2.12.52,4.36-.77,6.36l-1.5,6c-1.48.5,0,2.48-1.49,3l-1.88,2.62c-1.49,3.6-1.17,7.54-2.09,11.28a10.12,10.12,0,0,1-2.05,4.43c-2.54,2.94-3.33,6.7-4.3,10.18a21.09,21.09,0,0,0-.36,10.4c1.29,5,.36,10.08,1.32,15l.37.74c1.4,1.2,1.46,2.8,1.53,4.5.2,4.88-1.17,9.72-.39,14.6.24,1.57-1.4,1.66-1.89,2.63l-.37.75a44,44,0,0,1-3.74,13.66c-2.32,4.85-7.17,7.9-8.24,13.3-.23,1.13-1,2.38-.67,3.35,1.08,3.67-1.61,6.58-2.13,9.66a25.18,25.18,0,0,1-5.43,11.71l-.38.75c-.13,2,.8,2.35-1.47,8.24-1.84,4.77,6,9.33,6.35,14.54.24,3.62,1.11,7.23,1,10.93-.06,2.7,1.63,3.44,3.46,3.65s2.85.52,3.89,2.25c.69,1.16,2.25.31,4.39.62,1.56-1.72,4.05-1.68,6.22-2.4,4.21-1.39,8-.34,8.78,3.84,2.18,3.31,3,3,6.45,4.22l1.22-.33.2,2c-.72,2.6,1.7,4.58,2.93,6.71,2.32,4,2,9.59-.75,12.39a7.31,7.31,0,0,1-5.64,2.6c-3.81-.09-6.85,2.36-10.44,3.18-2.76.63-4.31,7.33-3,11a11,11,0,0,1,.57,6,3,3,0,0,0,.49,2.28c2.89,6.43,2.92,12.54-1,18.78-3.12,4.93-3.77,10.68-2.65,16.41.84,4.3-.74,7.19-3.71,10.21-4.67,4.75-8.36,10-9.71,17.09-1.14,6-1.35,12.75-6.11,17.65-2,2.1-3.12,4.83-4.88,7.1-1.23,1.6-1.24,3.42.08,4.44l-.43.08c-2.8,0-5.88-.17-8.17,1.23-4.94,3-10.35,3.64-15.79,3.93-6.15.33-9.95-2.06-8.06-9.29,1-3.92,2.27-7.83,1.51-12l.17-1.12c.18-4,1.54-8.3-2.19-11.65-.66-.59-.87-1.67-1.34-2.64l.55-.69c-1.79-1.23.43-3.84-1.52-4.82s-1.73-2.67-2.2-4.18a18,18,0,0,0-2.11-3.83c-2.67-4.41-8.2-6-9.45-12.21a65.68,65.68,0,0,1-.53-22.12c.95-6.86,1.8-13.76,2.88-20.61.74-4.74-2.35-10.08,2.05-14.29.24-.24,0-1,0-1.47.5-5,.67-10,1.28-15,1.07-8.73,1.53-17.5,3-26.23,1-5.88-.25-13.61,1.68-18.48v-2.67c-.87-4.72,1.57-8.13,1.61-9.11.18-4.38.7-4.95.61-6.45-.43-7.75,4.7-13.73,4-20.81-.65-6.39.91-12.79,2.34-19.05,1.22-5.38.61-11,2-16.32,1.22-4.79,1.4-9.72,1.86-14.61.38-4.12,1.3-8.15,1.28-12.36,0-2.18,1.81-4.26,1.75-6.74-.18-7.21,1.9-14.19,2.22-21.35.1-2.39,1.88-4.23,1.94-6.74.13-4.87.65-9.74,1.07-14.61a62.72,62.72,0,0,0,.69-6.36c-.19-9.42-3.44-20.06.71-28.4l.88-10.68c.53.55.39,1.09,0,1.74l10.44,9.25c2.28,2.48,6.06,2.51,8.27,5.21a25.76,25.76,0,0,0,9.71,7.12c3.69,1.63,7.48,3,11.22,4.52l.75.37c2.24.83,4.09,1.8,5.2.42l.41,0c1.25-.57,2.33.87,3.78.06l10.66-3.49,2.41-6.31"
              transform="translate(-7004.84 -6879.99)"
            />
            <path
              class="cls-4"
              :style="
                hoverCentral === basins[16]
                  ? { fill: '#3A5311', opacity: 1 }
                  : {
                      fill: sortedBasinOnlyNames.includes(basins[16])
                        ? coloring(basins[16])
                        : '#f8fcfd',
                    }
              "
              d="M7141,7169.93c.79-1.34,1.2-.4.94-1.67l.33-7.8c3.74-2.37,2.61-5.65,2.9-8.76v-7.49c.78-4.12,1-8.45,4.85-11.26a1.42,1.42,0,0,0,.37-1.1c-.36-4.22,2.65-6.89,4.47-10.14,1.13-2,2.7-4,2-6.74a3.25,3.25,0,0,1,2.15-3.74c2.77-1.18,5.49-2.48,8.24-3.73l.75-.37a23.91,23.91,0,0,0,4.49-6H7177c.54.54.88.92,1.91.44,2.06-1,1.57-3.33,3-4.56l.37-.75a5.89,5.89,0,0,1,3.74-3.75l.75-.37c1.58-.6.64-2.59,1.88-3.37l.74-1.5c.37-1.09,2.22-.38,2.25-1.87l6.36-4.12c2.58-3.29,7.07-4,9.74-7.12l1.12-1.12c1.45-.53.44-2.77,1.51-2.9,2.9-.35,3.24-2.81,4-4.63,1.21-2.83,2-5.82,4.58-7.82a1.18,1.18,0,0,0,.33-1.49c-1.26-2.35.77-3.23,1.91-4.51l.77-.62.35-.13,10.57,1.27c4.27,4.57,4.77,7.92,2.51,12.95a27.87,27.87,0,0,0-1.75,7.52c-.28,2-.68,3.14-2.65,4.23-2.55,1.41-2.92,4.85-4.91,7-2.81,3.06-5.19,6.49-8.23,9.37-2.79,2.62-4.59,6-6.41,9.33-1.92,3.53-4.49,6.68-5.28,10.86a123.5,123.5,0,0,0-2.11,18.36c-.09,2.45-.32,4.33-3.07,4.87l-.2.32-.93,1.18c-2.77,2.43-4.23,5.56-5.74,8.92-3.47,7.72-5.77,15.83-8.94,23.63-.93,2.28-.53,4.54-.92,6.79s-.55,4.36-1.61,6.35v2.25c-3.27,6.8-5,14.29-10,20.3a19.67,19.67,0,0,0-4.85,10.48l-.48.68c-6.67,2-8.91-4.21-12.52-7.36-1.07-.93-1.76-3.51-3.2-5H7151c-.17-2.53-.3-5.3-2.13-7-3.32-3-3.62-7.61-4.11-11.11l-.05-.83c-.17-3.84-1.76-12.17-1.73-14l-2-2.35"
              transform="translate(-7004.84 -6879.99)"
            />
            <!-- EDIT THIS ONE V -->
            <path
              class="cls-7"
              :style="
                hoverCentral === basins[6] || hoverCentral === basins[21]
                  ? { fill: '#3A5311' }
                  : { fill: coloring() }
              "
              d="M7107.41,7348.33l.75.38c4.62.18,7.33-2.29,11.42-3.4h1.94c7.22,6.21,4,13,5.4,20.11-4.21,1.31-8.12,1.27-12,1.26l-2.6,1.15c.38,3.85-1.43,5.4-2.39,8.93-2,7.41-.59,12.36,5.71,17.3a14.53,14.53,0,0,1,4.06,4.51c1.44,2.8,4.71,2.87,6.52,5.14,2.72,3.42,2.32,7,1,10.5a20.53,20.53,0,0,0-1.44,10.91c.9,6,1.55,6.56-4.54,9.38-1.54-1.14-2-4.63-2.89-6.28l-2.45-1.78c-4-.84-6.95-4.6-11.42-4.46-1.05,0-1.33-1.88-1.54-3.23-.89-5.64-2.07-11.17-5.91-15.77-1.82-2.19-1.72-8.53,0-10.81a15.33,15.33,0,0,0,2.93-11.25,45.22,45.22,0,0,0-3.3-11.25c-1.71-4.35-.74-9,2.66-10.34a9.65,9.65,0,0,0,4.43-3.88l.38-.75c1.25-1.75,2.49-3.5,3.74-5.24Z"
              transform="translate(-7004.84 -6879.99)"
            />
            <!-- EDIT THIS ONE V -->
            <path
              class="cls-8"
              :style="
                hoverCentral === basins[17] || hoverCentral === basins[21]
                  ? { fill: '#3A5311' }
                  : { fill: coloring(basins[17]) }
              "
              d="M7119.58,7345.31l3-2.08c6.09-6,9.37-11.14,6.89-20.37l-.75-4.12c.79-3.16,3.1-4.82,6-5.54a8.37,8.37,0,0,0,2.65-1.51c4.34-2.71,7.91-6.52,13-8.19,10.3-3.36,14.39-12.12,17.62-21.46l1.49-2.25c.57-2.37,2.08-3.24,4.49-3.43,3.95-.31,7.19,1.44,10.48,3.08,5.42,2.69,10.49.72,14-4.45s5.92-10.79,8.88-16.17l.75-1.13c1.5-.81,3-1.67,4.5-2.42,4.27-2.12,7.94-.92,11.6,3.73,3.45,4.41,5.71,4.69,10.86,1.71,6.8-3.92,12.42-9.59,19.48-13.09a39,39,0,0,1,7.85-3c2.68-.67,5.28-1.19,7.5-3s4.46-3.28,6.71-4.9l4.83,2.84,7,6.23c-.43,1.2,2.23,3.71,2.85,4.34,3.39,3.46,3.19,7.64,3.51,12a7.72,7.72,0,0,1-2.86,7.1c-3,2.62-6,5.46-9.39,7.41-4.18,2.38-4.53,6.8-6.63,10.26a186.78,186.78,0,0,1-13.64,19.72c-3,3.72-4.37,7.95-6.27,12.07-.77,1.69-.16,3.43.16,4.85l-2.48-2.16-12.25-.42a6.54,6.54,0,0,0-2.59.5c-6.37,3.82-16.6,20.29-28.25,30.42l-4,3.4a13.9,13.9,0,0,1-5.12,2.75c-13.2,3.86-24.38,11.37-48.66,9.35h-10.24c-4.74-.22-9.5.46-14.22-.37l-1.45-1.64c-1.43-7.13,1.82-13.9-5.4-20.11Z"
              transform="translate(-7004.84 -6879.99)"
            />
            <path
              class="cls-8"
              :style="
                hoverCentral === basins[8]
                  ? { fill: '#3A5311', opacity: 1 }
                  : {
                      fill: sortedBasinOnlyNames.includes(basins[8])
                        ? coloring(basins[8])
                        : '#f8fcfd',
                      stroke: '#fff',
                    }
              "
              d="M7174.11,7368.61c4-.07,26.1,1,25.89-.39,6.41-9,9.92-14.12,9.59-14.38l-1.79.2a20.12,20.12,0,0,1-6.13,3.46l-17.09,5.79-12.47,4.6Z"
              transform="translate(-7004.84 -6879.99)"
            />
            -
            <path
              class="cls-9"
              :style="
                hoverCentral === basins[7]
                  ? { fill: '#3A5311' }
                  : {
                      fill: sortedBasinOnlyNames.includes(basins[7])
                        ? coloring(basins[7])
                        : '#f8fcfd',
                      stroke: '#fff',
                    }
              "
              d="M7210.58,7351.92c11.65-10.13,21.88-26.6,28.25-30.42a6.54,6.54,0,0,1,2.59-.5l12.25.42,2.36,2.05.12.11c1.14,5-.16,9.22-3.94,12.32a21.55,21.55,0,0,0-7.92,12.48c-1,5.6-3.29,12,.93,17.38l-.28,2.77-15.77.69-9-.29-3.09-.62s-3.05.36-3.58.38-9.44.28-9.58.24-3.92,0-3.92,0l9.59-15.09Z"
              transform="translate(-7004.84 -6879.99)"
            />
            <path
              class="cls-10"
              :style="
                hoverCentral === basins[3]
                  ? { fill: '#3A5311', opacity: 1 }
                  : {
                      fill: sortedBasinOnlyNames.includes(basins[3])
                        ? coloring(basins[3])
                        : '#f8fcfd',
                      stroke: '#fff',
                    }
              "
              d="M7050.31,7336.34c1-3.92,2.27-7.83,1.51-12l.17-1.12c.18-4,1.54-8.3-2.19-11.65-.66-.59-.87-1.67-1.34-2.64l.55-.69c-1.79-1.23.43-3.84-1.52-4.82s-1.73-2.67-2.2-4.18a18,18,0,0,0-2.11-3.83c-2.67-4.41-8.2-6-9.45-12.21l.68,6.68c-3.46,3.55-1.65,8-1.73,12a16.38,16.38,0,0,0-.14,2.62l0,.91c1.41,1.87,0,3.66,0,5.54,0,11.61.16,23.14,0,34.75l.38.75c1.57,2.82-.5,5.45-.46,8.24.19,12.23.08,24.47.08,36.7l.38.75c1.24,4.84-.28,9.79.48,14.59.45,2.88-1.53,6.1.11,8.8l-.33,2c.09,7.42-1.47,17.16,1.61,14.27l3.74-16.48a102.39,102.39,0,0,0,5.27-15.52,6.3,6.3,0,0,0-.2-3.36l-.75-3.85a14.06,14.06,0,0,0-1.53-3.4,3.5,3.5,0,0,1,.64-4.89c3.54-3.45,4.11-7.55,3.26-12a25.2,25.2,0,0,1-.32-3.75l-2.62-4.12c-1.49-4.53.83-8.36,2.24-12.36l1.87-1.88c1.47-1.17,0-3.32,1.5-4.49Z"
              transform="translate(-7004.84 -6879.99)"
            />
            <path
              class="cls-11"
              :style="
                hoverCentral === basins[9]
                  ? { fill: '#3A5311', opacity: 1 }
                  : {
                      fill: sortedBasinOnlyNames.includes(basins[9])
                        ? coloring(basins[9])
                        : '#f8fcfd',
                      stroke: '#fff',
                    }
              "
              d="M7034.79,7431.85c.88-12.64,11.08-26.81,8.06-39.21-5.9-7.6,5.47-12.08,2.36-20.33a12.72,12.72,0,0,0-2.94-7.87c-1.28-5.08.72-10.69,4.12-14.24,1.13-2.93,3-10.49,3.92-13.86-1.79,19.46,22.38,3.26,32.23,4.21,8.48,8.23,20.18,3.07,25.24,8.9-12,16.18-15,9.63-7.91,31.47-7.05,26.77-3,13.28,3,37.83.3,4.95,11.77,5.36,15.41,9.47,1.5,3.7,3.57,7.45,1.89,11.36-1.94,1.75-5.46,3.22-7.75,1.34-.77-1.93-4-2.24-3.25.58a2.39,2.39,0,0,1,.08,2.17c.93,1.29,3.1,1.06,4.42.58,2,.89,5.72,1.27,7.5,2.75-2.5,3.18-10.43,2-14,2.33-4.71-.34-9.39.76-14.42.59-2.08-.5-4.25.83-3.25-1s-1-1.42,1.5-2.42a10.09,10.09,0,0,1,5.08-.5c-13.79-10.87-4.88-13.05-11.08-13.75-2.61.6-3.73-3.39-3.5-5.17-1.38-1.39-4.53-1-4.25-4-.25-.64,2.74-2.2,2.67-2.33,1.27-5.26,1.5-15.95.75-20.92-4.27-10.22-.32-2.8,0-10.58-1.49-4.79-1.84,2.72-4.42,1.5-2.41-.28-4.12-5.83-5-.33-3.36,3-.39,5.44-3.92,10.25,0,0,1.42.08-.58,2.91-2.47,4.47-.15,4-.92,7.25,0,0,1-.25-.08.92-3.73,2.08-1.23,4.67-3.08,7.75-.67.75.41-6.1-.34,2.62-.84,11.2,1.7,7.54-.83,12.73-1.81-2.25-2.56,7-2.92,7.82.83,1.19.76,3.35-1.75,2.08a4.54,4.54,0,0,1-2.25-2.78c-1.2-1.46-1.48,3.19-2.08,2.7-.75.08.25,3.08-1.5-.42s-3.92-2.25-1.5-4.08,2.67-1.84,2.75-2.34.92-.75-.75-1.08c-1.81,0-5.17-2.12-6.08-2.33-.34.08.91-1.84-.34.08s.84,1.42-1.25,1.92c-5.41,2.81-.35-4.09-5.16-3.59C7036.6,7433.44,7036.71,7433.3,7034.79,7431.85Z"
              transform="translate(-7004.84 -6879.99)"
            />
          </svg>

          <svg
            class="GradientLegend"
            viewBox="0 0 10 10"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <defs>
              <linearGradient id="myGradient" gradientTransform="rotate(0)">
                <stop offset="1%" stop-color="#99ddff" />

                <stop offset="50%" stop-color="#0077b3" />
                <stop offset="95%" stop-color="#00111a" />
              </linearGradient>
            </defs>

            <!-- using my linear gradient -->
            <rect width="8" height=".7" fill="url('#myGradient')" />
          </svg>
          <div class="legend">
            Lowest - Relative Impairment - Highest
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import * as d3 from "d3";
export default {
  data() {
    return {
      basins: [
        "Choctawhatchee",
        "Coosa",
        "Tombigbee",
        "Escatawpa",
        "Conecuh",
        "Tallapoosa",
        "Perdido",
        "Yellow",
        "Blackwater",
        "Mobile",
        "Black Warrior",
        "Tennessee",
        "Alabama",
        "Chattahoochee",
        "Upper Tombigbee",
        "Lower Tombigbee",
        "Cahaba",
        "Escambia",
        "Chipola",
        "Tombigbee (lower)",
        "Tombigbee (upper)",
        "Perdido-Escambia",
      ],
      activeColor: "#3A5311",
      filters: [
        "2000",
        "2002",
        "2004",
        "2006",
        "2008",
        "2010",
        "2012",
        "2014",
        "2016",
        "2018",
        "2020",
      ],
    };
  },
  name: "Modal",
  props: {
    scrollPosition: Number,
    counter: Number,
    modalYpos: Number,
    hoverCentral: String,
    sortedBasin: Array,
    sortedBasinOnlyNames: Array,
    modalYposEnd: Number,
  },
  computed: {
    scrollBlock() {
      return Math.floor(this.scrollPosition / 100);
    },
    scrollCheck() {
      if (
        this.scrollPosition < this.modalYpos - 190 ||
        this.scrollPosition > this.modalYposEnd + 1600 + 100
      ) {
        let result = "none";

        return result;
      } else {
        let result1 = "inline";
        return result1;
      }
    },
    scrollopacity() {
      if (
        this.scrollPosition < this.modalYpos - 90 ||
        this.scrollPosition > this.modalYposEnd + 1600 - 100
      ) {
        let result = 0;

        return result;
      } else {
        let result1 = 1;
        return result1;
      }
    },

    coloring() {
      let color = d3.scaleOrdinal([
        "#000000",
        "#00111a",
        "#002233",
        "#00334d",
        "#004466",
        "#005580",
        "#006699",
        "#0077b3",
        "#0088cc",
        "#0099e6",
        "#00aaff",
        "#1ab2ff",
        "#4dc3ff",
        "#66ccff",
        "#80d4ff",
        "#99ddff",
      ]);
      return color.domain(this.sortedBasinOnlyNames);
      //d3.scaleOrdinal().domain([‘A’, ‘B’, ‘C’]) .range([‘#fff’, ‘#8f8’, ‘#00f’])
    },
  },
  methods: {
    logit() {
      // console.log(this.coloring(this.basins[11]));
      // console.log(this.basins[11]);
    },

    // Tennessee
    emitToParent() {
      this.$emit("childToParent", this.hoverValue);
    },
  },
};
</script>

<style>
.Modal {
  position: fixed;
  top: 30vh;
  left: 0vw;
  width: 275px;
  height: 50vh;
  opacity: 1;
  margin-left: 3%;
  transform: scale(1.2, 1.2);
  visibility: visible;
  -webkit-transition: opacity 1s ease-out;
  -moz-transition: opacity 1s ease-out;
  -o-transition: opacity 1s ease-out;
  transition: opacity 1s ease-out;
  opacity: 1;
  /* // padding: 5px; */
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 1;
}
.container {
  display: grid;
  grid-template-columns: 80px auto 80px auto;
  grid-template-rows: 25% 100px 50px;
}
.scrollY {
  display: grid;
}
.child2 {
  grid-column-start: 3;
  text-align: center;

  margin-bottom: 15px;
  color: #111;
  font-family: "Open Sans", sans-serif;
  font-size: 40px;
  font-weight: 200;
  line-height: 32px;
  /* font-weight: bold; */
}
.child3 {
  grid-column-start: 5;
}
.child button {
  width: 80px;
  border-radius: 8px;
  margin-top: 30%;
  border: white;
}
.child3 button {
  width: 80px;
  border-radius: 8px;
  margin-top: 30%;
  border: white;
}
.item-a {
  display: grid;
  grid-column-start: 1;
  grid-column-end: span col4-start;
  grid-row-start: 2;
  grid-row-end: span 2;
}
.legend {
  margin-top: 5%;
  font-size: 0.8em;
}
.GradientLegend {
  margin-top: 145%;
  margin-left: 40px;
}
.item-a #svgimg {
  position: absolute;
}

.cls-1,
.cls-10,
.cls-11,
.cls-2,
.cls-3,
.cls-4,
.cls-5,
.cls-6,
.cls-7,
.cls-8,
.cls-9 {
  stroke: rgb(255, 255, 255);
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2px;
}
</style>
